export const getSubmissionURL = (): string => {
  return `${process.env.REACT_APP_FORMS_API}/forms/page-submission`;
};
